// Shared frontend constants
export const HTTP_UNAUTHORIZED = 401;
export const SCROLL_THRESHOLD_PX = 30;
export const MS_PER_DAY = 86_400_000;
export const MAX_UPLOAD_MB = 10;
